/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

type Props = {
  hasPadding?: boolean;
};

export const PlansGridColumns = styled.div<Props>`
  display: grid;
  grid-template-columns: 3rem minmax(10rem, 1fr) 20rem 20rem 10rem;
  padding: ${(props) => (props.hasPadding ? theme.spacing.spacing03 : "0")};
`;
